/* ===========================================================
   Mattress On Demand — Collection Carousel
   Shortcode: [collection-carousel="collection-handle"]
   Container: .blog-detail-content
   - Whole card clickable to product
   - Add-to-cart button (brand color)
   - Handles late-loaded content via MutationObserver
   =========================================================== */

(function () {
  const CONTAINER_SELECTOR = '.blog-detail-content';
  const SHORTCODE_RE = /\[collection-carousel="([^"]+)"\]/g;

  // run on DOM ready + again on window load, then observe
  ready(initWithObserver);

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
    window.addEventListener('load', fn, { once: true });
  }

  function initWithObserver() {
    processAll();
    // in case content is injected by the blog app after DOM ready
    const body = document.body;
    if (!body) return;
    const mo = new MutationObserver(() => {
      if (processAll()) {
        // stop when all shortcodes are gone
        if (!body.textContent.match(/\[collection-carousel="/)) mo.disconnect();
      }
    });
    mo.observe(body, { childList: true, subtree: true });
  }

  function processAll() {
    let didSomething = false;
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (!container) return false;

    // inject wrappers for each shortcode
    let idx = 0;
    const html = container.innerHTML;
    const replaced = html.replace(SHORTCODE_RE, (_, handle) => {
      didSomething = true;
      const id = `mod-carousel-${handle}-${idx++}`;
      return `
        <section id="${id}" class="mod-slider-wrapper mod-slider" data-collection="${handle}">
          <div class="swiper-container"><div class="swiper-wrapper"></div></div>
        </section>`;
    });

    if (replaced !== html) container.innerHTML = replaced;

    // build any new carousels
    container.querySelectorAll('.mod-slider-wrapper[data-collection]').forEach(buildCarousel);
    return didSomething;
  }

  /* ---------------- Build a single collection slider ---------------- */
  function buildCarousel(wrapper) {
    if (wrapper.__built) return; // guard double-build
    wrapper.__built = true;

    const handle   = wrapper.getAttribute('data-collection');
    const trackEl  = wrapper.querySelector('.swiper-wrapper');
    const swiperEl = wrapper.querySelector('.swiper-container');

    fetch(`/collections/${handle}/products.json?limit=12`)
      .then(r => r.json())
      .then(json => {
        (json.products || []).forEach(product => {
          const variant = product.variants && product.variants[0];
          if (!variant) return;

          const imgSrc = getPreferredImage(product.images);   // prefer first image
          const price  = formatPrice(variant.price);

          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          if (imgSrc) slide.style.backgroundImage = `url(${imgSrc})`;

          slide.innerHTML = `
            <a class="mod-slide-hit" href="/products/${product.handle}" aria-label="View ${escapeHtml(product.title)}"></a>
            <div class="product-name">${escapeHtml(product.title)}</div>
            <div class="product-price">${price}</div>
            <form class="purchase-form" action="/cart/add" method="post">
              <input type="hidden" name="id" value="${variant.id}">
              <button type="submit" class="purchase-btn" aria-label="Add ${escapeHtml(product.title)} to cart">
                Add To Cart
              </button>
            </form>
          `;
          trackEl.appendChild(slide);
        });

        waitForSwiper(() => {
          new Swiper(swiperEl, {
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 12,
            loop: false,
            navigation: false,
            pagination: false
          });
        });
      })
      .catch(err => console.error('MOD carousel error:', err));
  }

  /* ---------------- Helpers ---------------- */

  // For /collections/{handle}/products.json: images is [{src: "..."}]
  function getPreferredImage(images) {
    if (!images || !images.length) return '';
    const first  = images[0] && images[0].src;
    const second = images[1] && images[1].src;
    return first || second || '';
  }

  // Handle cents (number) or dollar strings with thousands separators
  function formatPrice(raw) {
    let dollars;
    if (typeof raw === 'number') dollars = raw / 100;
    else {
      const s = String(raw).trim();
      if (/^\d+$/.test(s)) dollars = parseInt(s, 10) / 100;
      else if (/^\d+(\.\d+)?$/.test(s)) dollars = parseFloat(s);
      else dollars = 0;
    }
    return dollars.toLocaleString(undefined, {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function waitForSwiper(cb) {
    if (window.Swiper) return cb();
    const iv = setInterval(() => { if (window.Swiper) { clearInterval(iv); cb(); } }, 50);
    setTimeout(() => clearInterval(iv), 3000);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
})();
